export const FETCH_SUBSCRIBER_VERIFICATION_DOCUMENT =
	'/subscriber/:id/verification/document/download';
export const FETCH_SUBSCRIBER_VERIFY =
	'/subscriber/:id/verification/markAsVerified';
export const FETCH_SUBSCRIBER_UNVERIFY =
	'/subscriber/:id/verification/markAsUnverified';
export const FETCH_SUBSCRIBER_STATUS = '/subscriber/:id';
export const FETCH_SUBSCRIBER_VERIFICATION_DOCUMENT_DETAILS =
	'subscriber/:id/verification/document/details';
